module.exports = __webpack_public_path__ + "media/promo/promo/images/recbg-3-33891ba41557b211ca78e60001980427.png";